
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api-vizum-01.lumixoticas.com.br'
});

 
// interceptor para enviar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vizumToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
